import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { openConsentPreferences } from "../services/cookieConsentService";

function Footer() {
  const { t } = useTranslation();
  const location = useLocation();

  // Hide footer on standalone landing pages
  if (location.pathname.startsWith('/garage/')) {
    return null;
  }

  // Hide footer in native app (Capacitor)
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
    return null;
  }

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        {/* Logo Section */}
        <div className="footer-logo-container">
          <Link to="/" className="footer-logo-link">
            <img
              src="/comparemechanic-logo.png"
              alt="CompareMechanic"
              className="footer-logo"
            />
          </Link>
        </div>

        {/* For Car Owners */}
        <div>
          <div className="footer-section-title">{t("footer.forCarOwners")}</div>
          <div className="footer-links">
            <Link to="/" className="footer-link">
              {t("footer.findGarage")}
            </Link>
            <Link to="/why-register" className="footer-link">
              {t("footer.whyRegister")}
            </Link>
            <Link to="/car-maintenance-tips" className="footer-link">
              {t("footer.carMaintenanceTips")}
            </Link>
            <Link to="/blog" className="footer-link">
              {t("footer.blog", "Blog")}
            </Link>
            <Link to="/book-appointment" className="footer-link">
              {t("footer.bookAppointment", "Book Appointment")}
            </Link>
            <Link to="/android-app" className="footer-link">
              {t("footer.androidApp", "Android App")}
            </Link>
          </div>
        </div>

        {/* For Garages */}
        <div>
          <div className="footer-section-title">{t("footer.forGarages")}</div>
          <div className="footer-links">
            <Link to="/claim-listing" className="footer-link">
              {t("footer.claimListing")}
            </Link>
            <Link to="/why-list" className="footer-link">
              {t("footer.whyList")}
            </Link>
            <Link to="/garage-contact" className="footer-link">
              {t("footer.connectWithUs")}
            </Link>
            <Link to="/marketing-tools" className="footer-link">
              {t("footer.marketingTools")}
            </Link>
            <Link to="/parts-accessories" className="footer-link">
              {t("footer.partsAccessories", "Parts & Accessories")}
            </Link>
          </div>
        </div>

        {/* Support */}
        <div>
          <div className="footer-section-title">{t("footer.support")}</div>
          <div className="footer-links">
            <Link to="/help-center" className="footer-link">
              {t("footer.helpCenter")}
            </Link>
            <Link to="/contact" className="footer-link">
              {t("footer.contactUs")}
            </Link>
            <Link to="/privacy-policy" className="footer-link">
              {t("footer.privacyPolicy")}
            </Link>
            <Link to="/terms" className="footer-link">
              {t("footer.termsOfService")}
            </Link>
            <Link to="/data-deletion" className="footer-link">
              {t("footer.dataDeletion")}
            </Link>
            <button
              onClick={openConsentPreferences}
              className="footer-link footer-cookie-btn"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                textAlign: "left",
                font: "inherit",
              }}
            >
              {t("footer.manageCookies", "Manage Cookies")}
            </button>
          </div>
        </div>
      </div>

      <div className="footer-divider" />

      <div className="footer-bottom">
        <div className="footer-email">
          <a href="mailto:contact@comparemechanic.com">
            <FaEnvelope className="footer-email-icon" />
            contact@comparemechanic.com
          </a>
        </div>

        <div className="footer-social">
          {/* FIXED: Updated social media links from generic to company-specific */}
          <a
            href="https://facebook.com/CompareMechanic"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://x.com/CompareMechanic"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <FaTwitter />
          </a>
          <a
            href="https://instagram.com/CompareMechanic"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/110163339"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>

        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} {t("footer.copyright")}
          <br />
          <span className="footer-attribution">
            {t("footer.dataBy")}{" "}
            <a
              href="https://www.openstreetmap.org/copyright"
              target="_blank"
              rel="noopener noreferrer"
            >
              OpenStreetMap contributors
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
